import { sxtheme } from 'utils/cssHelpers';

export const cardStyle = {
  width: ['calc(100vw - 32px)', 'calc(100vw - 32px)', 'calc(100vw - 32px)', '1038px'],
  maxWidth: ['calc(100vw - 32px)', '944px', '944px', '1038px'],
  minHeight: '348px',
  bg: 'white',
  boxShadow:
    '0px 3px 3px rgba(60, 63, 77, 0.07), 0px 3px 4px rgba(60, 63, 77, 0.08), 0px 1px 8px rgba(60, 63, 77, 0.14)',
  borderRadius: '4px',
  mt: ['16px', '16px', '24px'],
  overflow: 'hidden',
};

export const summaryPanelStyle = {
  width: ['100%', '100%', '277px'],
  minWidth: ['100%', '100%', '277px'],
  maxWidth: ['100%', '100%', '277px'],
  mb: ['24px', null, 'unset'],
};

export const detailsPanelStyle = {
  width: '100%',
  ml: [null, null, '48px'],
  bg: 'white',
};

export const detailsSectionStyle = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const skeletonSectionStyle = {
  width: '100%',
  height: '84px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: sxtheme(t => `1px solid ${t.colors.deepSea20}`),
};

export const disruptionPanelStyle = {
  width: '100%',
  padding: '8px 0',
  borderBottom: sxtheme(t => `1px solid ${t.colors.stone20}`),
};

export const disruptionFactorSectionStyles = {
  padding: '24px 0',
  display: [null, 'flex', 'flex'],
  borderBottom: sxtheme(t => `1px solid ${t.colors.stone20}`),
};

export const iconColumnStyle = {
  width: ['100%', '50%'],
  marginRight: ['0', '24px'],
  paddingBottom: ['16px', '0'],
};

export const detailColumnListStyle = {
  width: ['100%', '50%'],
  margin: '0',
  marginLeft: ['0', '24px'],
  paddingInlineStart: '18px',
  color: sxtheme(t => t.colors.stone70),
  '& li:not(:last-child)': {
    paddingBottom: '12px',
  },
};
